export const apiPath = '/v2/training_assignments';
const actionType = 'TRAINING_ASSIGNMENTS_V2';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
